import { Flex, Text } from '@chakra-ui/react';
import { IAdjudicatorFeedback } from '@publishing-engine/domain/models';
import MultilineText from 'src/components/MultilineText';
import { EditorialAttachments } from './EditorialAttachments';

export const AdjudicatorFeedback = ({
    adjudicatorFeedback = [],
    submissionContextId
  }: {
    adjudicatorFeedback?: IAdjudicatorFeedback[];
    submissionContextId: string;
  }) => {
    return adjudicatorFeedback.map(({ comment, attachments, adjudicationId }, index) => (
      <Flex key={adjudicationId} gap={2} flexDirection={'column'}>
        <Text textStyle="headingGroup">Feedback from Adjudicator {index + 1}</Text>
        <MultilineText textStyle="textBody" text={comment} />
        <EditorialAttachments attachments={attachments} submissionContextId={submissionContextId} />
      </Flex>
    ));
  };